import { createAction } from 'redux-actions';

export const startTestVideoChat = createAction('START_TEST_VIDEO_CHAT');
export const endTestVideoChat = createAction('END_TEST_VIDEO_CHART');
